import React, { useContext, useState } from 'react'
import { 
  StructuresContainer,
} from './style'
import CertificateFields from '../../../../components/Certificates/AddCertificate/Fields'
import CertificateStructures from '../../../../components/Certificates/AddCertificate/Structures'
import AddCertifateButtonsDiv from '../../../../components/Certificates/AddCertificate/ButtonsDiv'
import ImportCertificateToOcr from '../../../../components/Certificates/AddCertificate/ImportCertificateFile'
import CertificatesContext from '../../../../contexts/CertificatesContext'

const AddCertificateContent: React.FC = () => {
  const { forWhom } = useContext(CertificatesContext)
  // const { setStructureData, structureData } = useContext(CertificatesContext)

  return (
    <>
      {forWhom !== 'supplierWithPDF' ? 
      <>
        <CertificateFields/>
        <StructuresContainer>
          <CertificateStructures/>
          <AddCertifateButtonsDiv/>
        </StructuresContainer>
      </>
      : 
      <>
        <CertificateFields/>
        <StructuresContainer>
          {/* <ImportCertificateToOcr /> */}
          <AddCertifateButtonsDiv withoutSave={true} />
        </StructuresContainer>
      </>
      }
    </>
  )
}

export default AddCertificateContent